<div class="flex-calendar">
  <div *ngFor="let flexDay of this.getFlexCalendarDays(); trackBy: trackBy" class="flex-day">
    <div [ngClass]="flexDay.classTitle || ''" class="week-day">{{ flexDay.name }}</div>
    <div (click)="onSelectDay(flexDay)" [ngClass]="flexDay.class || ''" class="round-btn date-btn">
      {{ flexDay.dateNumber }}
    </div>
  </div>
</div>
